import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAppUsersLastUpdated } from '@redux/modules/app-users/selectors';
import { fetchAppUserStatistics } from '@redux/modules/app-users/actions';
import Loader from '@components/Loader';

import styles from './styles.module.css';

const getTimeFromNow = (timestamp: number) => {
    if (!timestamp) {
        return 'Не обновлялось';
    }

    return moment(timestamp).fromNow();
};

export interface Props {
    title: string;
    count: number | string;
}

export const AppUserCounter: React.FC<Props> = ({ title, count }) => {
    const [lastUpdated, setLastUpdated] = useState('');
    const dispatch = useDispatch();

    const appUsersLastUpdated = useSelector(getAppUsersLastUpdated);

    const onRefresh = () => dispatch(fetchAppUserStatistics());

    useEffect(() => {
        setLastUpdated(getTimeFromNow(appUsersLastUpdated));

        const interval = setInterval(() => {
            setLastUpdated(getTimeFromNow(appUsersLastUpdated));
        }, 60 * 1000);

        return () => {
            clearInterval(interval);
        };
    }, [appUsersLastUpdated]);

    return (
        <div className={styles.container}>
            <div className={styles.note}>{lastUpdated}</div>
            <button className={styles.refreshBtn}>
                <FontAwesomeIcon icon="sync" onClick={onRefresh} />
            </button>
            <h4 className={styles.subtitle}>{title}</h4>
            {count ? <h1 className={styles.title}>{count}</h1> : <Loader />}
        </div>
    );
};

export default AppUserCounter;
